import { render, staticRenderFns } from "./TicketSubmitterDetail.vue?vue&type=template&id=22d03641&scoped=true"
import script from "./TicketSubmitterDetail.vue?vue&type=script&lang=js"
export * from "./TicketSubmitterDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketSubmitterDetail.vue?vue&type=style&index=0&id=22d03641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d03641",
  null
  
)

export default component.exports